<div class="accordion-item"
     [class.is-open]="expanded()" [class.is-disabled]="disabled()">

  <button type="button"
          class="accordion-header"
          [attr.aria-expanded]="expanded()"
          [disabled]="expanded()"
          (click)="toggle()">

    <span class="accordion-header__content ts-h5-sans">
      <ng-content select="[header]"></ng-content>
    </span>

    <ion-icon class="accordion-header__chevron"
              [class.is-open]="expanded()"
              name="chevron-down"></ion-icon>
  </button>

  <div class="accordion-body" [class.is-open]="expanded()">
    <div class="accordion-body__inner">
      <ng-content></ng-content>
    </div>
  </div>

</div>
